import { render, staticRenderFns } from "./prixmoyencreateForm.vue?vue&type=template&id=5d21542a&"
import script from "./prixmoyencreateForm.vue?vue&type=script&lang=js&"
export * from "./prixmoyencreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports